import { render, staticRenderFns } from "./GoogleMyBusiness.vue?vue&type=template&id=c0d03674&scoped=true&"
import script from "./GoogleMyBusiness.vue?vue&type=script&lang=js&"
export * from "./GoogleMyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./GoogleMyBusiness.vue?vue&type=style&index=0&id=c0d03674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d03674",
  null
  
)

export default component.exports